import React, { useEffect } from 'react';
import './ConfirmationModal.css';

function ConfirmationModal({
  isOpen,
  type = 'warning', // warning, danger, info, success
  title,
  message,
  confirmLabel,
  cancelLabel,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}) {
  const displayConfirmLabel = confirmLabel || confirmText || 'Confirm';
  const displayCancelLabel = cancelLabel || cancelText || 'Cancel';

  // Prevent body scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const renderIcon = () => {
    switch (type) {
      case 'danger':
        return (
          <div className="modal-icon-container danger">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </div>
        );
      case 'success':
        return (
          <div className="modal-icon-container success">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
        );
      case 'info':
        return (
          <div className="modal-icon-container info">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
          </div>
        );
      case 'warning':
      default:
        return (
          <div className="modal-icon-container warning">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
        );
    }
  };

  return (
    <div className="modal-backdrop-overlay">
      <div className="modal-card-container" role="dialog" aria-modal="true">
        {/* Close Button in header */}
        <button className="modal-close-icon-btn" onClick={onCancel} aria-label="Close dialog">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="modal-content-wrapper">
          {renderIcon()}
          
          <div className="modal-text-content">
            <h3 className="modal-title-heading">{title}</h3>
            <p className="modal-description-text">{message}</p>
          </div>
        </div>

        <div className="modal-footer-actions">
          <button type="button" className="modal-btn modal-btn-cancel" onClick={onCancel}>
            {displayCancelLabel}
          </button>
          <button type="button" className={`modal-btn modal-btn-confirm ${type}`} onClick={onConfirm}>
            {displayConfirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
